/**
 * Rövidíti a szöveget, ha hosszabb a megadott max hossznál.
 * A végére "..." kerül, és az eredmény hossza sosem haladja meg a max értéket.
 *
 * @param text - A bemeneti szöveg
 * @param maxLength - Maximális hossz (a "..." is beleszámít)
 * @returns Rövidített szöveg
 */
export function truncateWithEllipsis(text: string, maxLength: number): string {
  if (!text) return '';
  if (text.length <= maxLength) return text;

  return text.slice(0, Math.max(0, maxLength - 3)) + '...';
}

/**
 * Egy (esetleg többsoros) szöveget folyószöveggé alakít: az egymás után
 * következő whitespace-eket (sortörések, tabok, szóközök — akár többet is
 * egymás után) egyetlen szóközzé vonja össze, majd az elejéről/végéről
 * levágja a maradékot.
 *
 * @param text - A bemeneti szöveg
 * @returns Egysoros, körbevágott szöveg
 */
export function toSingleLineText(text: string): string {
  return text.replace(/\s+/g, ' ').trim();
}
